<template>
  <div>
    <PageHeaderWithTab
      pre-title="회원"
      :title="presentPageTitle"
      :has-amount="true"
      :tab-menu="menus"
    />
    <div>
      <div
        class="calendar input-search el-input el-input--prefix"
      >
        <input
          type="text"
          class="el-input__inner"
          @input="handleInputSearchKeyword"
          placeholder="회원 이름, 전화번호 검색"
        >
        <span class="el-input__prefix">
          <i class="el-input__icon el-icon-search" />
        </span>
      </div>
    </div>

    <empty-table 
      v-if="searchKeyword.length && !searchTableData.length"
      :props-loading-status="searchTableLoading"
      :props-has-parent="emptyTableProps.hasParent"
      :props-is-icon="emptyTableProps.isIcon"
      :props-header-height="emptyTableProps.headerHeight"
      :props-data="emptyTableProps.data"
      :props-table-body-height="emptyTableProps.bodyHeight"
      :props-message="emptyTableProps.message" 
    />
    <empty-table 
      v-else-if="!searchKeyword.length && !memberTableData.length"
      :props-loading-status="memberTableLoading"
      :props-has-parent="emptyTableProps.hasParent"
      :props-is-icon="emptyTableProps.isIcon"
      :props-header-height="emptyTableProps.headerHeight"
      :props-data="emptyTableProps.data"
      :props-table-body-height="emptyTableProps.bodyHeight"
      :props-message="emptyTableProps.message" 
    />
    <el-table
      v-else-if="searchKeyword === '' && memberTableData.length"
      v-loading="memberTableLoading"
      :data="memberTableData"
      :row-class-name="setRowClassName"
      style="width: 100%"
      class="fifl-main-table member-list-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      cell-class-name="fifl-main-table-cell"
      @expand-change="onChangeMemberTableExpand"
      @filter-change="onChangeMemberTableFilter"
      @sort-change="onChangeSort"
      @row-click="handleClickRow"
    >
      <el-table-column
        sortable
        prop="member.name"
        column-key="member__user__name"
        label="이름"
        fixed="left"
        :min-width="columnWidth.name+'px'"
      />
      <el-table-column
        sortable
        prop="member.gender"
        column-key="member__gender"
        label="성별"
        :min-width="columnWidth.gender + 'px'"
      >
        <template slot-scope="scope">
          {{ scope.row.member.gender === 1 ? '남성' : '여성' }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="member.birth"
        label="생년월일"
        :min-width="columnWidth.birth + 'px'"
        column-key="member__birth"
      >
        <template slot-scope="scope">
          {{ presentBirth(scope.row.member.birth) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="member.phone_number"
        label="핸드폰 번호"
        :min-width="columnWidth.phone + 'px'"
      />
      <el-table-column
        column-key="parent_membership"
        show-overflow-tooltip
        :min-width="columnWidth.membership + 'px'"
        :filters="parentMembershipForFilterBox"
        filter-placement="bottom"
      >
        <template slot="header">
          최신 회원권
          <popover
            placement="bottom"
          >
            회원에게 배정된 회원권 중 종료일이 가장 늦은<br>회원권을 의미합니다. 종료일이 같은 최신 회원권이<br>여러 개일 경우 리스트 메뉴를 열어 확인하실 수<br>있습니다.
          </popover> 
        </template>
        <template slot-scope="scope">
          <section class="membership-row">
            <!-- expandble row open true : whole text visible -->
            <article 
              v-if="scope.row.isExpandOpen" 
              class="membership-row__expand"
            >
              <span>{{ scope.row.latest_membership.name }}</span>
            </article>
            <!-- expandble row open false : ~외 3 표현 -->
            <article 
              v-else 
              class="membership-row__unexpand"
            >
              <span>{{ scope.row.latest_membership.name }}</span>
              <span>{{ "외 " + scope.row.sameEndDayMemberships.length +"개" }}</span>
            </article>
          </section>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        :width="columnWidth.start"
        prop="latest_membership.start"
        column-key="latest_membership__start"
      >
        <template 
          slot="header" 
        > 
          시작일
          <popover
            placement="bottom"
          >   
            회원권이 시작되는 일자입니다. 최신<br>회원권이 여러 개일 경우 대표 회원권의 <br>시작일을 의미합니다.    
          </popover>
        </template>
        <template slot-scope="scope">
          {{ presentDate(scope.row.latest_membership.start) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="latest_membership.end"
        :min-width="columnWidth.end + 'px'"
        column-key="latest_membership__end"
      >
        <template 
          slot="header" 
        > 
          종료일
          <popover
            placement="bottom"
          >   
            회원권이 종료되는 일자입니다. 최신<br>회원권이 여러 개일 경우 대표 회원권의 <br>종료일을 의미합니다.    
          </popover>
        </template>
        <template slot-scope="scope">
          {{ presentDate(scope.row.latest_membership.end) }}
          <el-status-tag
            v-show="presentEndTag(scope.row.latest_membership.end) !== null"
            :label="presentEndTag(scope.row.latest_membership.end)"
            style="margin-left: 7px;"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="parent_courses"
        column-key="parent_courses"
        show-overflow-tooltip
        :min-width="columnWidth.course"
        :filters="courseFilter"
      >
        <template 
          slot="header" 
        > 
          수업
          <popover
            placement="bottom"
          >   
            회원이 수강할 수 있는 모든 수업입니다.<br>최신 회원권이 여러 개일 경우 대표 회원권의<br>수업만 표시됩니다.    
          </popover>
        </template>
        <template slot-scope="scope">
          {{ presentParentCourseNames(scope.row.latest_membership) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        :min-width="columnWidth.consumed + 'px'"
        column-key="latest_membership__consumed"
      >
        <template 
          slot="header"
        > 
          {{ '수강 ' + membershipSystem.middle }}
          <popover
            placement="bottom"
          >   
            회원권으로 소진한 총 {{ membershipSystem.long }}입니다.</br>최신 회원권이 여러 개일 경우 대표 회원권의<br>수강 {{ membershipSystem.long }}만 표시됩니다.    
          </popover>
        </template>
        <template
          slot-scope="scope"
        >
          {{ numberWithCommas(scope.row.latest_membership.consumed + scope.row.latest_membership.wait_consumed) }}
        </template>
      </el-table-column>
      <el-table-column
        type="expand"
        label=""
        fixed="right" 
        :min-width="columnWidth.empty + 'px'"
      >
        <template slot-scope="scope">
          <section>
            <ul 
              v-for="membership in scope.row.sameEndDayMemberships"
              :key="membership.id"
            >
              <li :style="{width : expandRowWidth[0] + 'px'}" />
              <li :style="{width : expandRowWidth[1] + 'px'}" />
              <li :style="{width : expandRowWidth[2] + 'px'}" />
              <li :style="{width : expandRowWidth[3] + 'px'}" />
              <li :style="{width : expandRowWidth[4] + 'px'}">
                <p>{{ membership.name }}</p>
              </li>
              <li :style="{width : expandRowWidth[5] + 'px'}">
                <p>{{ presentDate(membership.start) }}</p>
              </li>
              <li :style="{width : expandRowWidth[6] + 'px'}">
                <p>
                  {{ presentDate(membership.end) }}          
                  <el-status-tag
                    v-show="presentEndTag(scope.row.latest_membership.end) !== null"
                    :label="presentEndTag(scope.row.latest_membership.end)"
                    style="margin-left: 7px;"
                  />
                </p>    
              </li>
              <li :style="{width : expandRowWidth[7] + 'px'}">
                <p>{{ presentParentCourseNames(membership) }}</p>
              </li>
              <li :style="{width : expandRowWidth[8] + 'px'}">
                <p>{{ membership.consumed }}</p>
              </li>
              <li :style="{width : expandRowWidth[9] + 'px'}" />
            </ul>
          </section>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-else-if="searchTableData.length"
      v-loading="searchTableLoading"
      :data="searchTableData"
      :row-class-name="setRowClassName"
      style="width: 100%"
      class="fifl-main-table member-list-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      cell-class-name="fifl-main-table-cell"
      @expand-change="onChangeMemberTableExpand"
      @filter-change="onChangeMemberTableFilter"
      @sort-change="onChangeSort"
      @row-click="handleClickRow"
    >
      <el-table-column
        sortable
        prop="member.name"
        column-key="member__user__name"
        label="이름"
        fixed="left"
        :min-width="columnWidth.name+'px'"
      />
      <el-table-column
        sortable
        prop="member.gender"
        column-key="member__gender"
        label="성별"
        :width="columnWidth.gender"
      >
        <template slot-scope="scope">
          {{ presentGender(scope.row.member.gender) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="member.birth"
        label="생년월일"
        :width="columnWidth.birth"
        column-key="member__birth"
      >
        <template slot-scope="scope">
          {{ presentBirth(scope.row.member.birth) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="member.phone_number"
        label="핸드폰 번호"
        :min-width="columnWidth.phone+'px'"
      />
      <el-table-column
        prop="latest_membership.name"
        show-overflow-tooltip
        :min-width="columnWidth.membership + 'px'"
      >
        <template slot="header">
          최신 회원권
          <popover
            placement="bottom"
          >
            회원에게 배정된 회원권 중 종료일이 가장 늦은<br>회원권을 의미합니다. 종료일이 같은 최신 회원권이<br>여러 개일 경우 리스트 메뉴를 열어 확인하실 수<br>있습니다.
          </popover> 
        </template>
        <template slot-scope="scope">
          <section class="membership-row">
            <!-- expandble row open true : whole text visible -->
            <article 
              v-if="scope.row.isExpandOpen" 
              class="membership-row__expand"
            >
              <span>{{ scope.row.latest_membership.name }}</span>
            </article>
            <!-- expandble row open false : ~외 3 표현 -->
            <article 
              v-else 
              class="membership-row__unexpand"
            >
              <span>{{ scope.row.latest_membership.name }}</span>
              <span>{{ "외 " + scope.row.sameEndDayMemberships.length +"개" }}</span>
            </article>
          </section>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        :min-width="columnWidth.start+'px'"
        prop="latest_membership.start"
        column-key="latest_membership__start"
      >
        <template 
          slot="header" 
        > 
          시작일
          <popover
            placement="bottom"
          >   
            회원권이 시작되는 일자입니다. 최신<br>회원권이 여러 개일 경우 대표 회원권의 <br>시작일을 의미합니다.    
          </popover>
        </template>
        <template slot-scope="scope">
          {{ presentDate(scope.row.latest_membership.start) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="latest_membership.end"
        :min-width="columnWidth.end+'px'"
        column-key="latest_membership__end"
      >
        <template 
          slot="header" 
        > 
          종료일
          <popover
            placement="bottom"
          >   
            회원권이 종료되는 일자입니다. 최신<br>회원권이 여러 개일 경우 대표 회원권의 <br>종료일을 의미합니다.    
          </popover>
        </template>
        <template slot-scope="scope">
          {{ presentDate(scope.row.latest_membership.end) }}
          <el-status-tag
            v-show="presentEndTag(scope.row.latest_membership.end) !== null"
            :label="presentEndTag(scope.row.latest_membership.end)"
            style="margin-left: 7px;"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="parent_courses"
        column-key="parent_courses"
        show-overflow-tooltip
        :min-width="columnWidth.course"
        :filters="courseFilter"
      >
        <template 
          slot="header" 
        > 
          수업
          <popover
            placement="bottom"
          >   
            회원이 수강할 수 있는 모든 수업입니다.<br>최신 회원권이 여러 개일 경우 대표 회원권의<br>수업만 표시됩니다.    
          </popover>
        </template>
        <template slot-scope="scope">
          {{ presentParentCourseNames(scope.row.latest_membership) }}
        </template>
      </el-table-column>
      <el-table-column
        sortable      
        :min-width="columnWidth.consumed+'px'"
        column-key="latest_membership__consumed"
      >
        <template 
          slot="header" 
        > 
          {{ '수강 ' + membershipSystem.middle }}
          <popover
            placement="bottom"
          >   
            회원권으로 소진한 총 {{ membershipSystem.long }}입니다.</br>최신 회원권이 여러 개일 경우 대표 회원권의<br>수강 {{ membershipSystem.long }}만 표시됩니다.    
          </popover>
        </template>
        <template
          slot-scope="scope"
        >
          {{ numberWithCommas(scope.row.latest_membership.consumed + scope.row.latest_membership.wait_consumed) }}
        </template>
      </el-table-column>
      <el-table-column
        type="expand"
        label=""
        fixed="right" 
        :min-width="columnWidth.expand+'px'"
      >
        <template slot-scope="scope">
          <section>
            <ul 
              v-for="membership in scope.row.sameEndDayMemberships" 
              :key="membership.id"
            >
              <li :style="{width : expandRowWidth[0] + 'px'}" />
              <li :style="{width : expandRowWidth[1] + 'px'}" />
              <li :style="{width : expandRowWidth[2] + 'px'}" />
              <li :style="{width : expandRowWidth[3] + 'px'}" />
              <li :style="{width : expandRowWidth[4] + 'px'}">
                <p>{{ membership.name }}</p>
              </li>
              <li :style="{width : expandRowWidth[5] + 'px'}">
                <p>{{ presentDate(membership.start) }}</p>
              </li>
              <li :style="{width : expandRowWidth[6] + 'px'}">
                <p>
                  {{ presentDate(membership.end) }}          
                  <el-status-tag
                    v-show="presentEndTag(scope.row.latest_membership.end) !== null"
                    :label="presentEndTag(scope.row.latest_membership.end)"
                    style="margin-left: 7px;"
                  />
                </p>    
              </li>
              <li :style="{width : expandRowWidth[7] + 'px'}">
                <p>{{ presentParentCourseNames(membership) }}</p>
              </li>
              <li :style="{width : expandRowWidth[8] + 'px'}">
                <p>{{ membership.consumed }}</p>
              </li>
              <li :style="{width : expandRowWidth[9] + 'px'}" />
            </ul>
          </section>
        </template>
      </el-table-column>
    </el-table>
    <div
      v-show="totalDataCount.length !== 0 && searchKeyword === ''"
      style="text-align: center; margin-top: 25px;"
    >
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="curPage"
        :total="totalDataCount"
        @current-change="onChangeCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import dateFns from 'date-fns';
import Popover from '@/components/popover';
import EmptyTable from '@/components/EmptyTable';
import PageHeaderWithTab from '@/components/element-ui/PageHeaderWithTab';
import ElStatusTag from '@/components/element-ui/ElStatusTag';
import _ from 'lodash';
import { computedGetters } from '@/utils/vuex-helper';
import {
  SameEndMembershipSerializer,
  ExpiredMembershipFilter
} from '@/utils/filter';
import { numberWithCommas, removeEmojis } from '@/utils/etc';
import { convertStringDigitToDate } from '@/utils/date-helper';
import { fiflboxApi } from '@/utils/api';
import resizePageMixin from '@/mixins/resizePageMixin';

const PAGE_TYPE = {
  VALID: 'valid',
  EXPIRED: 'expired'
};

const COL_COUNT = 10;

export default {
  name: 'MemberList',
  mixins: [resizePageMixin],
  components: {
    Popover,
    EmptyTable,
    ElStatusTag,
    PageHeaderWithTab
  },
  data() {
    return {
      curDate: dateFns.startOfDay(new Date()),
      curPage: 1,
      pageAmount: 10,
      searchKeyword: '',
      searchTableData: [],
      memberTableData: [],
      totalDataCount: 0,
      memberTableLoading: false,
      searchTableLoading: false,
      hasFilter: false,
      initialLoad: false,
      columnWidth: {
        name: 90,
        gender: 85,
        birth: 90,
        phone: 95,
        membership: 300,
        start: 100,
        end: 140,
        course: 'calc(100% - 1050px)',
        consumed: 100,
        empty: 50
      },
      expandRowWidth: [90, 85, 90, 95, 300, 100, 140, 200, 100, 50],
      emptyTableProps: {
        message: '등록 된 회원이 없습니다.',
        headerHeight: 43,
        bodyHeight: 410,
        isIcon: true,
        hasParent: false,
        data: [
          { label: '이름', width: 90 + 'px' },
          { label: '성별', width: 85 + 'px' },
          { label: '생년월일', width: 90 + 'px' },
          { label: '핸드폰 번호', width: 95 + 'px' },
          { label: '최신 회원권', width: 160 + 'px' },
          { label: '시작일', width: 100 + 'px' },
          { label: '종료일', width: 140 + 'px' },
          { label: '수업', width: 'calc(100% - 945px)' },
          { label: '수강 횟수', width: 100 + 'px' },
          { label: '', width: 50 + 'px' }
        ]
      },
      memberQueryOptions: {
        parentCourseFilter: [],
        parentMembershipFilter: [],
        order: null
      }
    };
  },
  async mounted() {
    await this.syncMemberList();
    await this.$store.dispatch('syncParentMemberships');
    this.onResize();
  },
  watch: {
    isRegisteredMemberMenuVisible: {
      immediate: true,
      handler: function(isAccessAllowed) {
        if (!isAccessAllowed) {
          this.$router.push('/announce/access-block'.catch(() => {}));
        }
      }
    }
  },
  computed: {
    ...computedGetters([
      'membershipSystem',
      'publicParentCourseNames',
      'parentCourses',
      'parentMembershipForFilterBox',
      'isRegisteredMemberMenuVisible'
    ]),
    menus() {
      return [
        {
          title: '전체',
          value: 'total',
          amount: this.totalDataCount
        }
      ];
    },
    courseFilter() {
      return this.parentCourses
        .map(course => {
          return {
            text: `${course.is_removed ? '(삭제)' : ''}${course.name}`,
            value: course.id
          };
        })
        .sort((before, after) => {
          const isBeforeCourseRemoved = before.text.includes('(삭제)');
          const isAfterCourseRemoved = after.text.includes('(삭제)');
          if (isBeforeCourseRemoved && !isAfterCourseRemoved) {
            return 1;
          }
          if (!isBeforeCourseRemoved && isAfterCourseRemoved) {
            return -1;
          }
          return 0;
        });
    },
    memberListType() {
      return this.$route.name === 'main/member/expired'
        ? PAGE_TYPE.EXPIRED
        : PAGE_TYPE.VALID;
    },
    presentPageTitle() {
      return this.memberListType === PAGE_TYPE.VALID
        ? '유효 회원'
        : '만료 회원';
    }
  },
  methods: {
    numberWithCommas,
    removeEmojis,
    async handleInputSearchKeyword($event) {
      this.searchTableData = [];
      this.searchKeyword = this.removeEmojis($event.target.value);
      this.searchTableLoading = true;
      this.searchDataByKeyword();
    },
    searchDataByKeyword: _.debounce(async function() {
      if (this.searchKeyword === '') {
        return;
      }
      let searchKeyword = this.searchKeyword + '';

      let { data } = await fiflboxApi.v1.getEnrollmentMembers({
        is_valid: this.memberListType === PAGE_TYPE.VALID ? '1' : '0',
        status: 'APPROVAL',
        search: searchKeyword
      });
      if (searchKeyword === this.searchKeyword) {
        if (data.length) {
          await SameEndMembershipSerializer(data);
          this.memberListType === PAGE_TYPE.VALID
            ? await ExpiredMembershipFilter(data)
            : null;
        }
        this.searchTableData = data;
      }
      this.searchTableLoading = false;
    }, 600),
    format: dateFns.format,
    handleClickRow(row, column, event) {
      document.getSelection().removeAllRanges();
      let isNewTab = event.shiftKey;
      let memberId = row.id;

      if (isNewTab) {
        let routeData = this.$router.resolve({ path: `/member/${memberId}` });
        return window.open(routeData.href, '_blank');
      }

      this.$router.push(`/member/${memberId}`).catch(() => {});
    },

    presentParentCourseNames(membership) {
      return _.union(
        this.publicParentCourseNames,
        membership.parent_courses
      ).join(', ');
    },
    presentGender(gender) {
      return gender % 2 === 1 ? '남' : '여';
    },
    presentBirth(birth) {
      return dateFns.format(convertStringDigitToDate(birth), 'YYYY.MM.DD');
    },
    presentDate(date) {
      return dateFns.format(date, 'YYYY.MM.DD');
    },
    presentEndTag(date) {
      if (dateFns.isAfter(this.curDate, date)) {
        return null;
      }

      let dayCount = dateFns.differenceInDays(date, this.curDate);

      if (dayCount > 7) {
        return null;
      }

      if (dayCount === 0) {
        return 'D-DAY';
      }
      return 'D-' + dayCount;
    },
    onChangeMemberTableExpand(row, expand) {
      const { isSameEndDayMembership } = row;
      if (isSameEndDayMembership && expand.length) {
        return (row.isExpandOpen = true);
      } else if (isSameEndDayMembership && !expand.length) {
        return (row.isExpandOpen = false);
      }
      return (row.isExpandOpen = true);
    },
    onChangeMemberTableFilter(filters) {
      this.hasFilter = false;
      const { parent_courses, parent_membership } = filters;
      if (parent_courses && parent_courses.length) {
        this.hasFilter = true;
        this.memberQueryOptions.parentCourseFilter = parent_courses;
      } else {
        this.memberQueryOptions.parentCourseFilter = [];
      }
      if (parent_membership && parent_membership.length) {
        this.hasFilter = true;
        this.memberQueryOptions.parentMembershipFilter = parent_membership;
      } else {
        this.memberQueryOptions.parentMembershipFilter = [];
      }
      this.setFirstPage();
      this.syncMemberList();
    },
    onChangeSort({ column, order }) {
      if (column === null) {
        this.memberQueryOptions.order = null;
      } else {
        this.memberQueryOptions.order =
          (order === 'ascending' ? '' : '-') + column.columnKey;
      }

      this.setFirstPage();
      this.syncMemberList();
    },
    onResize() {
      const elColGroup = document.querySelector('colgroup');
      if (elColGroup) {
        for (let colIndex = 0; colIndex < COL_COUNT; colIndex++) {
          const indexColChildren = elColGroup.children[colIndex];
          if (indexColChildren) {
            const indexColWidth = indexColChildren.getAttribute('width');
            if (this.expandRowWidth[colIndex] !== indexColWidth) {
              this.expandRowWidth[colIndex] = indexColWidth;
            }
          } else {
            continue;
          }
        }
      }
    },
    setFirstPage() {
      return (this.curPage = 1);
    },
    setRowClassName({ row: rowData }) {
      const { isSameEndDayMembership } = rowData;
      let className = 'fifl-table-row';
      if (!isSameEndDayMembership) {
        className += ' fifl-table-row__unexpandable';
      } else {
        className += ' fifl-table-row__expandable';
      }
      return className;
    },
    makeMemberListQuery() {
      let params = {
        is_valid: this.memberListType === PAGE_TYPE.VALID ? '1' : '0',
        status: 'APPROVAL',
        offset: (this.curPage - 1) * 10,
        limit: this.pageAmount
      };

      let {
        parentMembershipFilter,
        parentCourseFilter,
        order
      } = this.memberQueryOptions;

      if (parentCourseFilter.length > 0) {
        params.courses = parentCourseFilter.join(',');
      }

      if (parentMembershipFilter.length > 0) {
        params.membership = parentMembershipFilter.join(',');
      }

      if (order) {
        params.ordering = order;
      } else {
        params.ordering =
          this.memberListType === PAGE_TYPE.VALID
            ? 'latest_membership__end'
            : '-latest_membership__end';
      }

      return params;
    },
    async syncMemberList() {
      this.memberTableLoading = true;
      const params = this.makeMemberListQuery();
      const { data } = await fiflboxApi.v1.getEnrollmentMembers(params);
      if (data.results.length) {
        await SameEndMembershipSerializer(data.results);
        this.memberListType === PAGE_TYPE.VALID
          ? await ExpiredMembershipFilter(data.results)
          : null;
      }
      this.memberTableData = data.results;
      if (this.hasFilter && !this.memberTableData.length) {
        const title = '필터링된 데이터가 없습니다.';
        const message =
          '본 회원권을 가진 회원이 존재하지 않습니다. 확인 버튼을 누르면 필터링 옵션이 초기화된 상태로 돌아갑니다.';
        await this.$alert(message, title);
        await this.resetParams();
        await this.setFirstPage();
        await this.syncMemberList();
        return;
      }
      this.totalDataCount = data.count;
      this.memberTableLoading = false;
      this.initialLoad = true;
    },
    onChangeCurrentPage() {
      this.syncMemberList();
    },
    resetParams() {
      this.memberQueryOptions.parentCourseFilter = [];
      this.memberQueryOptions.parentMembershipFilter = [];
      this.memberQueryOptions.order = null;
    }
  }
};
</script>

<style lang="scss">
.member-list-table {
  .el-table__expanded-cell {
    padding: 0;
    border-bottom: 1px solid #fcfcfc;
    section {
      width: 100%;
      ul {
        background-color: #fcfcfc;
        margin: 0;
        display: flex;
        width: 100%;
        height: 46px;
        box-sizing: border-box;
        li {
          line-height: 18px;
          letter-spacing: -0.8px;
          text-overflow: ellipsis;
          height: 46px;
          box-sizing: border-box;
          position: relative;
          p {
            font-size: 13px;
            min-width: 50px;
            word-break: break-all;
            color: #4a4a4a;
            text-align: left;
            padding: 13px 10px 13px 13px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 0;
          }
        }
      }
    }
  }

  .membership-row {
    .membership-row__expand {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .membership-row__unexpand {
      display: flex;
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      span {
        &:first-child {
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &:last-child {
          width: 80px;
          margin-left: 5px;
        }
      }
    }
  }
}
.member-list-table .dashkit * {
  z-index: 1 !important;
}

.fifl-table-row__unexpandable {
  .el-table__expand-icon {
    visibility: hidden;
  }
}

.el-table__expand-icon {
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  .el-icon-arrow-right::before {
    content: '\e605';
  }
}

.el-table__expand-icon--expanded {
  transform: rotate(180deg);
}

.input-search {
  width: 240px;
  margin-bottom: 18px;

  input.el-input__inner {
    font-size: 15px;
    letter-spacing: -0.8px;
    color: #4a4a4a;

    &::placeholder {
      font-size: 15px;
      letter-spacing: -0.8px;
      color: #4a4a4a;
    }
  }
}
</style>
